<ng-container *ngIf="!isBonusPathV2Active">
  <ng-container *ngIf="continuity.progressValue === 0 && !isClipped">
      <button [ngClass]="{'btn':true, 'grid-coupon-btn':true, 'btn-default':true , 'loading-coupon-item': showLoadingCoupon}"
              role="button" id="couponAddBtn{{id}}" (click)="startChallenge()" (keydown.enter)="startChallenge()"
              [attr.aria-describedby]="startChallengeLabel">{{startChallengeLabel}}</button>
  </ng-container>
  <ng-container *ngIf="isClipped && continuity.progressValue >= 0 && continuity.progressValue < continuity.targetValue">
      <div class="progress-offer-status">
          <span class="progress-msg">{{offerDataDisplay(continuity).prefix}}:&nbsp;</span>
          <span class="pgs-lwrlmt">{{offerDataDisplay(continuity).progressVal}}&nbsp;</span>
          <span class="limit-separator">/&nbsp;</span>
          <span class="pgs-uprlmt">{{offerDataDisplay(continuity).targetVal}}&nbsp;</span>
          <!-- <span class="pgs-sold">{{continuity?.units | lowercase}}</span> -->
      </div>
      <!-- <progressbar max="{{continuity.targetValue}}" value="{{continuity.progressValue}}" [animate]="false"></progressbar> -->
  </ng-container>
  <ng-container *ngIf="isClipped && continuity.progressValue === continuity.targetValue">
      <div class="challenge-info">
      <span [attr.aria-describedby]="challengeCompletedLabel">
          <svg width="16px" height="16px" class="svg-icon svg-icon-coupon-carousel-tick-mark" aria-hidden="true" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Symbols" stroke-width="1" fill-rule="evenodd">
                  <g id="Icons-/-Universal-/-Check-/-Gray" attr.fill="{{challengeCompletedLabelColor}}">
                      <polygon id="GreenCheck" points="19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236"></polygon>
                  </g>
              </g>
          </svg>
      </span>
      <span class="status" [ngStyle]="{'color': challengeCompletedLabelColor, 'fontSize': fontSize}">{{challengeCompletedLabel}}</span>
      </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isBonusPathV2Active">
  <ng-container *ngIf="!isCouponClipped">
      <ng-container *ngIf="!isOfferDetailsPage && !isCouponCarosel">
          <div class="grid-coupon-clip-button-wrapper">
              <div id="clippedCouponGrid{{ couponData?.couponID }}" [ngClass]="{
                      'grid-coupon-clip-button': true,
                      clipped: couponData?.status == 'C'
                  }">
                  <button *ngIf="this.couponData.status && this.couponData.status === 'U' && !this.couponData.deleted" [ngClass]="{
                          btn: true,
                          'grid-coupon-btn': true,
                          'btn-default': true,
                          'loading-coupon-item': showLoadingCoupon
                      }" role="button" id="couponAddBtn{{ id }}" (click)="startChallenge()"
                      (keydown.enter)="startChallenge()" [attr.aria-describedby]="startChallengeLabel">
                      {{ startChallengeLabel }}
                  </button>
                  <button *ngIf="this.couponData.status && this.couponData.status === 'U' && this.couponData.deleted" [ngClass]="{
                      btn: true,
                      'grid-coupon-btn': true,
                      'btn-default': true,
                      'loading-coupon-item': showLoadingCoupon
                  }" role="button" id="couponAddBtn{{ id }}" (click)="startChallenge()"
                  (keydown.enter)="startChallenge()" [attr.aria-describedby]="startChallengeLabel">
                  {{behavioralOfferAttrs.addToMyListBtnText}}
              </button>
              </div>
          </div>
      </ng-container>
      <ng-container *ngIf="isOfferDetailsPage && !isCouponCarosel">
          <button *ngIf="this.couponData.status && this.couponData.status === 'U' && !this.couponData.deleted" [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showLoadingCoupon}" role="button" id="offerDetailButton{{ id }}"
          (click)="startChallenge()" (keydown.enter)="startChallenge()"
                      [attr.aria-describedby]="startChallengeLabel">
                      {{ startChallengeLabel }}
                  </button>
          <button *ngIf="this.couponData.status && this.couponData.status === 'U' && this.couponData.deleted" [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showLoadingCoupon}" role="button" id="offerDetailButton{{ id }}"
          (click)="startChallenge()" (keydown.enter)="startChallenge()"
                      [attr.aria-describedby]="startChallengeLabel">
                      {{behavioralOfferAttrs.addToMyListBtnText}}
                  </button>
      </ng-container>
      <ng-container *ngIf="isCouponCarosel">
          <button  type="button" class="btn btn-md btn-primary"
          [attr.aria-describedby]="startChallengeLabel"
          (click)="startChallenge()" id="couponAddBtn{{id}}">{{ startChallengeLabel }}</button>
      </ng-container>
  </ng-container>
  <ng-container *ngIf="isCouponClipped">
      <ng-container *ngIf="!isBonusPathCompleted">
          <ng-container *ngIf="isContinuityCoupon">
              <div class="progress-offer-status">
                  <span class="progress-msg">{{
                      offerDataDisplay(couponData?.continuity).prefix
                      }}:&nbsp;</span>
                  <span class="pgs-lwrlmt">{{
                      offerDataDisplay(couponData?.continuity).progressVal
                      }}&nbsp;</span>
                  <span class="limit-separator">/&nbsp;</span>
                  <span class="pgs-uprlmt">{{
                      offerDataDisplay(couponData?.continuity).targetVal
                      }}&nbsp;</span>
              </div>
              <span *ngIf="isOfferDetailsPage && continuityOfferService.isFreshpassContinuityCoupon(couponData)" class="behaviour-link body-text-xs ml-2 float-right">
                  <a role="link" href={{behavioralOfferAttrs.startShoppingLink}} class="links__action links__action__inline underline" (click)="navigateTo(behavioralOfferAttrs.startShoppingLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.startShoppingLink)">{{behavioralOfferAttrs.startShoppingText}}</a>
              </span>
              <!-- <div class="progress" style="height: 6px;">
                <div class="progress-bar" role="progressbar" style="width: 50%;" attr.aria-valuenow="{{ couponData?.continuity.progressValue }}" aria-valuemin="0" attr.aria-valuemax="{{couponData?.continuity.targetValue}}"></div>
              </div> -->
              <progressbar [ngClass] = "{'m-0':!isOfferDetailsPage}" [max]="convertString(couponData?.continuity.targetValue)"
                  [value]="convertString(couponData?.continuity.progressValue)" [animate]="false">
              </progressbar>
              <span *ngIf="!isOfferDetailsPage && continuityOfferService.isFreshpassContinuityCoupon(couponData)" class="behaviour-link body-text-xs ">
                  <a role="link" href={{behavioralOfferAttrs.startShoppingLink}} class="links__action links__action__inline underline" (click)="navigateTo(behavioralOfferAttrs.startShoppingLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.startShoppingLink)">{{behavioralOfferAttrs.startShoppingText}}</a>
              </span>
          </ng-container>
          <ng-container *ngIf="isBehaviorCoupon">
              <div class="progress-behaviour-status" *ngIf="!isOfferDetailsPage">
                  <span class="body-text-xs">{{ behavioralOfferAttrs?.inProgressStatusText }}</span>
                  <span class="behaviour-link-container">
                      <span class="behaviour-link body-text-xs">
                          <a class="links__action links__action__inline underline" *ngIf="
                                  couponData?.qualificationBehavior.trim().toLowerCase() ===
                                  behavioralOfferAttrs?.grClipTextOMS.trim().toLowerCase()
                              " (click)="navigateTo(behavioralOfferAttrs.grClipLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.grClipLink)"  role="link" href={{behavioralOfferAttrs.grClipLink}}>{{ behavioralOfferAttrs?.grClipButtonText }}</a>
                          <a class="links__action links__action__inline underline" *ngIf="
                                  couponData?.qualificationBehavior.trim().toLowerCase() ===
                                  behavioralOfferAttrs?.ucaEmailOptInTextOMS.trim().toLowerCase()
                              " (click)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)"
                              (keydown.enter)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)" role="link" href={{behavioralOfferAttrs.ucaEmailOptInLink}}>{{ behavioralOfferAttrs?.ucaEmailOptInButtonText }}</a>
                          <a class="links__action links__action__inline underline" *ngIf="
                                  couponData?.qualificationBehavior.trim().toLowerCase() === behavioralOfferAttrs?.ecomFulfillmentTextOMS.trim().toLowerCase()
                              " (click)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)"
                              (keydown.enter)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)"  role="link" href={{behavioralOfferAttrs.ecomFulfillmentLink}}>{{ behavioralOfferAttrs?.ecomFulfillmentButtonText }}</a>
                      </span>
                  </span>
              </div>
              <ng-container *ngIf="isOfferDetailsPage">
                  <button *ngIf="
                                              couponData?.qualificationBehavior ===
                                              behavioralOfferAttrs?.grClipTextOMS
                                                  " [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showLoadingCoupon}" role="button" id="offerDetailButton{{ id }}"
                      (click)="navigateTo(behavioralOfferAttrs.grClipLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.grClipLink)"
                      [attr.aria-describedby]="couponData?.qualificationBehavior">
                      {{ behavioralOfferAttrs?.grClipButtonText }}
                  </button>
                  <button *ngIf="
                              couponData?.qualificationBehavior ===
                              behavioralOfferAttrs?.ucaEmailOptInTextOMS
                                  " [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showLoadingCoupon}" role="button" id="offerDetailButton{{ id }}" (click)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)"
                      (keydown.enter)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)" [attr.aria-describedby]="couponData?.qualificationBehavior">
                      {{ behavioralOfferAttrs?.ucaEmailOptInButtonText }}
                  </button>
                  <button *ngIf="couponData?.qualificationBehavior === behavioralOfferAttrs?.ecomFulfillmentTextOMS"
                  [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showLoadingCoupon}" role="button" id="offerDetailButton{{ id }}" (click)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)"
                      (keydown.enter)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)" [attr.aria-describedby]="couponData?.qualificationBehavior">
                      {{ behavioralOfferAttrs?.ecomFulfillmentButtonText }}
                  </button>
              </ng-container>
          </ng-container>
      </ng-container>
      <ng-container *ngIf="isBonusPathCompleted">
          <div class="challenge-info" [ngClass] = "{'m-0':!isOfferDetailsPage}">
              <span [attr.aria-describedby]="challengeCompletedLabel">
                  <svg width="16px" height="16px" class="svg-icon svg-icon-coupon-carousel-tick-mark" aria-hidden="true"
                      viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Symbols" stroke-width="1" fill-rule="evenodd">
                          <g id="Icons-/-Universal-/-Check-/-Gray" attr.fill="{{ challengeCompletedLabelColor }}">
                              <polygon id="GreenCheck"
                                  points="19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236">
                              </polygon>
                          </g>
                      </g>
                  </svg>
              </span>
              <span class="status" [ngStyle]="{
                      color: challengeCompletedLabelColor,
                      fontSize: fontSize
                  }">{{ challengeCompletedLabel }}</span>
              <span *ngIf="isOfferDetailsPage && continuityOfferService.isFreshpassContinuityCoupon(couponData)" class="behaviour-link body-text-xs ml-2">
                  <a role="link" href={{behavioralOfferAttrs.freshPassOfferLink}} class="links__action links__action__inline underline" (click)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)">{{behavioralOfferAttrs.freshPassOfferText}}</a>
              </span>
              <span *ngIf="isOfferDetailsPage && !continuityOfferService.isFreshpassContinuityCoupon(couponData)" class="behaviour-link body-text-xs ml-2">
                  <a role="link" href={{behavioralOfferAttrs.myListLink}} class="links__action links__action__inline underline" (click)="navigateTo(behavioralOfferAttrs.myListLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.myListLink)">{{behavioralOfferAttrs.viewInMyListText}}</a>
              </span>
          </div>
          <div *ngIf="!isOfferDetailsPage && continuityOfferService.isFreshpassContinuityCoupon(couponData)" class="behaviour-link body-text-xs ml-2">
              <a role="link" href={{behavioralOfferAttrs.freshPassOfferLink}} class="links__action links__action__inline underline" (click)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)" (keydown.enter)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)">{{behavioralOfferAttrs.freshPassOfferText}}</a>
          </div>
      </ng-container>
  </ng-container>
</ng-container>